import { getStbClient, RequestOptions } from './fetch';

export type Customer = {
  email: string;
  phoneNumber: string;
  customerId?: string | null;
  customerNumber?: string | null;
  name?: string;
};

export async function getCustomer(
  options: RequestOptions = {}
): Promise<Customer | null> {
  const client = await getStbClient();

  const response = await client.get(`/customer/core-data.v3`, {
    timeout: 8000,
    ...options
  });

  if (response.status === 204) {
    return null;
  }

  const json: any = await response.data;

  return {
    phoneNumber: json.contactMethods?.mobilePrivate?.value?.value ?? '',
    email: json.contactMethods?.emailPrivate?.value?.value ?? '',
    customerId:
      json.identificationNumbers?.find(
        (id: any) => id.value.type === 'customerId'
      ).value?.value ?? '',
    name: `${json.names?.official?.value?.givenNameOne ?? ''} ${
      json.names?.official?.value?.lastName ?? ''
    }`
  };
}

export async function updateCustomerV3(customer: Customer): Promise<any> {
  const client = await getStbClient();

  const customerData = {
    emailPrivate: customer.email,
    mobilePrivate: customer.phoneNumber
  };

  return client.patch(`/customer/core-data.v3`, customerData);
}
